import { c as _c } from "react/compiler-runtime";
import { Button } from '@material-bank/mb3-components';
import { ShareIcon } from '@material-bank/mtag-icons';
import { useWebShare } from '@material-bank/mtag-utilities';
import { useTranslations } from '@material-bank/i18n';
type ShareButtonProps = {
  analyticsId?: string;
  size?: 'icon' | 'icon-lg';
  title?: string;
  text?: string;
  url?: string;
};
export function ShareButton(t0) {
  const $ = _c(14);
  const {
    analyticsId,
    size: t1,
    title,
    text,
    url
  } = t0;
  const size = t1 === undefined ? "icon" : t1;
  const t = useTranslations("product");
  let t2;
  if ($[0] !== text || $[1] !== title || $[2] !== url) {
    t2 = {
      title,
      text,
      url
    };
    $[0] = text;
    $[1] = title;
    $[2] = url;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    share
  } = useWebShare(t2);
  let t3;
  if ($[4] !== share) {
    t3 = function clickHandler() {
      share();
    };
    $[4] = share;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const clickHandler = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t("share");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ShareIcon fill="none" width={16} height={16} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== analyticsId || $[10] !== clickHandler || $[11] !== size || $[12] !== t4) {
    t6 = <Button type="button" size={size} variant="secondary" aria-label={t4} onClick={clickHandler} data-haptic="light" data-analyticsid={analyticsId}>{t5}</Button>;
    $[9] = analyticsId;
    $[10] = clickHandler;
    $[11] = size;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}